export const PER_PAGE = 20;
export const PER_PAGE_OPTIONS = [10, 20, 50];
